<template>
  <div class="strategyInfo ashComWrap">
    <div class="comTitle">
      <h4>策略信息</h4>
    </div>
    <div class="comContentBox overflowWrap" v-if="strategyData.id">
      <el-descriptions :column="1" style="width: 90%; margin: 0 auto">
        <el-descriptions-item label="策略建立时间">{{
          dateFtt("yyyy-MM-dd hh:mm:ss", new Date(strategyData.createdTime))
        }}</el-descriptions-item>
        <el-descriptions-item label="初次建立人">{{
          strategyData.createdInfo.name ? strategyData.createdInfo.name : "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="策略最近更改时间">{{
          dateFtt("yyyy-MM-dd hh:mm:ss", new Date(strategyData.updatedTime))
        }}</el-descriptions-item>
        <el-descriptions-item label="策略范围">
          {{ strategyData.range }}
        </el-descriptions-item>
        <el-descriptions-item label="注意事项">{{
          strategyData.remark
        }}</el-descriptions-item>
      </el-descriptions>
    </div>
    <el-empty class="comContentBox" v-else description="暂无信息"></el-empty>
  </div>
</template>

<script>
import { dateFtt } from "@/assets/js/utils";
export default {
  props: {
    strategyData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  methods: { dateFtt },
  // watch: {
  //   strategyData: {
  //     handler(newvalue, oldvalue) {
  //       console.log(this.strategyData);
  //     },
  //     deep: true,
  //     immediate: true,
  //   },
  // },
};
</script>

<style lang="scss" scoped>
.strategyInfo {
  width: 100%;
  height: 300px;
  .overflowWrap {
    overflow: auto;
  }
}
</style>
